// extracted by mini-css-extract-plugin
module.exports = {"titleWidth":"35%","dateAddedWidth":"25%","tagsWidth":"25%"};